import { Box, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';

import { Wrapper } from './TrlPanel.styles';

export const TabPanel = ({ children, value, index, ...other }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { pathname } = useLocation();

  const [windowSize, setWindowSize] = useState(window.innerHeight);

  const listRef = useRef(null);
  const listsHeight =
    // eslint-disable-next-line react-hooks/refs
    listRef.current && windowSize - listRef.current.offsetTop - 71 - 56;

  // Add a window resize event listener
  useEffect(() => {
    const handleResize = () => {
      // Update the state with the new window size
      setWindowSize(window.innerHeight);
    };

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Wrapper
      ref={listRef}
      listsHeight={pathname === '/Dashboard' && isMobile ? 'auto' : listsHeight}
      role="tabpanel"
      hidden={value !== index}
      id={`issue-tabpanel-${index}`}
      aria-labelledby={`issue-tab-${index}`}
      noPaddingBottom={pathname === '/Dashboard' && isMobile}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Wrapper>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
